import { ContactsService } from './services/ContactsService';
import type { Init, ContactsTierSelectUrlAdapter } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import type { WidgetLifecycle } from '../WidgetLifecycle';
import { WithApi } from '../WithApi';

export type ContactsTierSelectData = MergedDataReturnType<[ContactsService]>;

export type ContactsTierSelectHandlers = MergedHandlersReturnType<[ContactsService]>;

type TApi = ReturnType<ContactsService['api']>;

export class ContactsTierSelectManager extends WithApi<TApi> {
  constructor(private urlAdapter: ContactsTierSelectUrlAdapter) {
    super();
  }

  public contactsTierSelectInit = ({ pageStore, queries, flags, t }: Init) => {
    const [planGroupQuery, contactsCountQuery] = queries;

    const pending = planGroupQuery.isPending || contactsCountQuery.isPending;

    const error = planGroupQuery.error || contactsCountQuery.error;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
        lifecycle: {} as WidgetLifecycle,
      } as const;
    }

    const contacts = new ContactsService(
      pageStore,
      planGroupQuery.data,
      contactsCountQuery.data,
      this.urlAdapter,
      flags,
      t
    );

    this.initApi({
      ...contacts.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...contacts.data(),
      },
      handlers: {
        ...contacts.handlers(),
      },
      lifecycle: {
        onMount() {
          contacts.onMount();
        },
      } as WidgetLifecycle,
    } as const;
  };
}
